import { apiCrm } from '../../../../http';

class NotPurchasedReportService {
  getRegisters(recordTypeIds, { dateBegin, dateEnd, page = 1, size = 10, ...params }) {
    return apiCrm.get(`not-purchased-report`, {
      params: {
        ...params,
        initialDate: dateBegin,
        finalDate: dateEnd,
        recordTypeIds: Array.isArray(recordTypeIds)
          ? recordTypeIds
          : [recordTypeIds],
        page,
        size
      }
    });
  }

  async getExcel(params) {
    return apiCrm.get('/not-purchased-report/export/xlsx', {
      params: {
        ...params,
        recordTypeIds: Array.isArray(params.recordTypeId)
          ? params.recordTypeId
          : [params.recordTypeId]
      },
      responseType: 'arraybuffer'
    });
  }

  async getCsv(params) {
    return apiCrm.get('/not-purchased-report/export/csv', {
      params: {
        ...params,
        recordTypeIds: Array.isArray(params.recordTypeId)
          ? params.recordTypeId
          : [params.recordTypeId]
      },
      responseType: 'arraybuffer'
    });
  }
}

export default new NotPurchasedReportService();
